module.exports = __webpack_public_path__ + "media/images/xpass/icons/checkmark-green-1eafc1754873a60269644b55240ad5a4.svg";